import { Forward } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ForwardInfo } from '../types';

interface ForwardHeaderProps {
  forwardInfo: ForwardInfo;
  isOutgoing?: boolean;
  className?: string;
}

/**
 * Компонент для отображения заголовка пересланного сообщения
 */
export function ForwardHeader({ forwardInfo, isOutgoing, className }: ForwardHeaderProps) {
  // Determine the source name
  const sourceName = forwardInfo.fromName || (forwardInfo.postAuthor ? `Канал · ${forwardInfo.postAuthor}` : 'Пересланное сообщение');

  return (
    <div
      className={cn(
        'flex items-center gap-2 mb-1 pb-1 border-b',
        isOutgoing ? 'border-white/20' : 'border-border',
        className
      )}
    >
      {/* Forward icon */}
      <Forward
        className={cn(
          'h-3.5 w-3.5 flex-shrink-0',
          isOutgoing ? 'text-white/60' : 'text-muted-foreground'
        )}
      />

      {/* Source info */}
      <div className="flex-1 min-w-0">
        <p
          className={cn(
            'text-xs font-medium truncate',
            isOutgoing ? 'text-white/80' : 'text-primary'
          )}
        >
          {sourceName}
        </p>
        {forwardInfo.channelPost && (
          <p
            className={cn(
              'text-[10px] truncate',
              isOutgoing ? 'text-white/50' : 'text-muted-foreground'
            )}
          >
            Сообщение #{forwardInfo.channelPost}
          </p>
        )}
      </div>
    </div>
  );
}
